
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule, SystemModule, TruckModule } from "@/store/modules/";
import notifications from "@/lib/notifications";
import * as modals from "@/lib/modals";
import Select from "@/components/form/Select.vue";
import { DriverManifestRequest } from "@/models/api/trucks/driverManifest";

const truckModule = getModule(TruckModule);
const systemModule = getModule(SystemModule)

@Component({
  name: modals.driverManifestModal,
  components: { Select },
})
export default class DriverManifestModal extends Mixins(mixin) {
  deliveryDate: any = null;
  facilityCode: string = null;

  async created() {
    if (systemModule.facilities && systemModule.facilities.length == 1)
      this.facilityCode = systemModule.facilities[0].facilityCode;
  }

  load() {
    this.show();
  }

  reset() {
    this.deliveryDate = null;
  }

  async downloadDriverManifests() {

    if (this.facilityCode && this.deliveryDate) {
      let request: DriverManifestRequest = {
        facilityCode: this.facilityCode,
        deliveryDate: this.deliveryDate
      };

      try {
        await truckModule.downloadDriverManifest(request);


      } catch (ex) {
        notifications.error(
          "Driver Manifest Download",
          "Failed to download driver manifests",
          ex
        );
      }
    }
  }

  get showFacilitySelect() {
    return systemModule.facilities && systemModule.facilities.length != 1;
  }
}
